export const LOCALES = {
  EN: 'en',
  ES: 'es',
  PT_BR: 'pt-BR',
};

export const ptRegex = /pt/;

export const esRegex = /es/;
